const textFieldFormService = {
  accountable: 'Responsable',
  document: 'Documento de Identidad',
  description: 'Comentarios'
};

export default textFieldFormService;
